import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-popup-header-title',
    templateUrl: './popup-header-title.component.html',
    styleUrls: ['./popup-header-title.component.scss'],
    standalone: false
})
export class PopupHeaderTitleComponent {
    @Input({required: true})
    public title!: string;
}
